/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgRectangle03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 117 24"
    data-name="SvgRectangle03"
    {...props}
  >
    {props.children}
    <path
      fill="#C9DDE9"
      d="M12 .458h102.069c.856 0 1.548.697 1.542 1.553l-.069 9.986v.006l.069 9.986a1.54 1.54 0 0 1-1.542 1.553H12C5.626 23.542.458 18.374.458 12S5.626.458 12 .458"
    />
    <path
      fill="url(#rectangle03_svg__a)"
      fillOpacity={0.2}
      d="M12 .458h102.069c.856 0 1.548.697 1.542 1.553l-.069 9.986v.006l.069 9.986a1.54 1.54 0 0 1-1.542 1.553H12C5.626 23.542.458 18.374.458 12S5.626.458 12 .458"
    />
    <path
      stroke="url(#rectangle03_svg__b)"
      strokeWidth={0.917}
      d="M12 .458h102.069c.856 0 1.548.697 1.542 1.553l-.069 9.986v.006l.069 9.986a1.54 1.54 0 0 1-1.542 1.553H12C5.626 23.542.458 18.374.458 12S5.626.458 12 .458Z"
    />
    <defs>
      <linearGradient
        id="rectangle03_svg__a"
        x1={34.981}
        x2={40.047}
        y1={-2.907}
        y2={24.159}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="rectangle03_svg__b"
        x1={9.795}
        x2={13.263}
        y1={0.45}
        y2={28.489}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.7} />
        <stop offset={0.406} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={0.574} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.4} />
      </linearGradient>
    </defs>
  </svg>
)
